import { render, staticRenderFns } from "./diff_line_discussions.vue?vue&type=template&id=61f928b1&vue3"
import script from "./diff_line_discussions.vue?vue&type=script&lang=js&vue3"
export * from "./diff_line_discussions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports